import styles from "../Shared/NavigationBar.module.scss";
import { Link } from "react-router-dom";
import DropDown from "../assets/components/dropdown";

function NavigationBar() {
  return (
    <div className={styles.navigationbar}>
      {/* <-------LOGO---------> */}
      <Link to="/" className={styles.logocontainer}>
        ABDULSAMAD
      </Link>

      {/* <-------Links---------> */}
      <div className={styles.bottomnav}>
        <div className={styles.linkscontainer}>
          <Link to="/" className={styles.link}>
            Home
          </Link>
          <Link to="portfolio" className={styles.link}>
            Portfolio
          </Link>
          <Link to="Resume" className={styles.link}>
            Resume
          </Link>
          <Link to="contact" className={styles.link}>
            Contact
          </Link>

          {/* <div className={styles.link}>Edit </div> */}
          <DropDown></DropDown>
        </div>
      </div>
    </div>
  );
}

export default NavigationBar;
